/**
 * Los `**dobles asteriscos**` que manda el servidor, en negrita de verdad.
 *
 * Los mensajes de la API llevan Markdown ligero —«los datos del tutor se leen
 * pero **no se importan**»— porque el mismo texto lo enseña el panel, una app y
 * un correo. Pintarlo crudo saca los asteriscos por pantalla.
 *
 * `BFF_BO.md` §3.5 dice que `title` y `detail` **se enseñan tal cual**, y esto no
 * lo contradice: no reescribe el mensaje, lo pinta como estaba escrito. Lo que no
 * se hace es inventarse otro texto.
 *
 * Y no hay `dangerouslySetInnerHTML` por ninguna parte: se parte la cadena y se
 * devuelven nodos de React, así que un `<script>` en el mensaje saldría como el
 * texto `<script>` y no como una etiqueta.
 */
import { Fragment, type ReactNode } from 'react';

export function TextoConEnfasis({ texto }: { texto: string }): ReactNode {
  // Los trozos impares son los que iban entre asteriscos.
  const trozos = texto.split('**');

  return trozos.map((trozo, i) =>
    i % 2 === 1 ? (
      <strong key={i}>{trozo}</strong>
    ) : (
      <Fragment key={i}>{trozo}</Fragment>
    )
  );
}
